var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 17.5C35 27.165 27.165 35 17.5 35C7.83502 35 0 27.165 0 17.5C0 7.83502 7.83502 0 17.5 0C27.165 0 35 7.83502 35 17.5Z",
    fill: "#083857"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_398_360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9963 24.9999V24.9993H25V19.498C25 16.8068 24.4207 14.7336 21.2744 14.7336C19.7619 14.7336 18.7469 15.5636 18.3325 16.3505H18.2888V14.9849H15.3057V24.9993H18.4119V20.0405C18.4119 18.7349 18.6594 17.4724 20.2763 17.4724C21.8694 17.4724 21.8932 18.9624 21.8932 20.1243V24.9999H24.9963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2471 14.9858H13.3571V25.0002H10.2471V14.9858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8013 10C10.8069 10 10 10.8069 10 11.8013C10 12.7956 10.8069 13.6194 11.8013 13.6194C12.7956 13.6194 13.6025 12.7956 13.6025 11.8013C13.6019 10.8069 12.795 10 11.8013 10V10Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_398_360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.ae646f211dda0106b2bcc1d5a63686fc.svg";
export { ForwardRef as ReactComponent };